import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {catchError, map, mergeMap, tap} from 'rxjs/operators';
import { of } from 'rxjs';
import { loadUserFailed, loadUserStart, loadUserSucceeded } from '../actions/getUser.actions';
import {UserService} from '../../user.service';
import {stringify} from '@angular/compiler/src/util';
import {loadFirmaStart} from "../../../Mitarbeiterverwaltung/store/actions/getFirma.actions";
import {loadUserRollenStart} from '../../../Mitarbeiterverwaltung/store/actions/getUserRollen.actions';
import {loadRollenStart} from '../../../Mitarbeiterverwaltung/store/actions/rolle.actions';

@Injectable()
export class UserEffects {
    /**
     * Loads the address list when dispatching the start action
     */
    public loadUser$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadUserStart),
            mergeMap((email) =>
                this.userService.getUser(email.email).pipe(
                    tap((item) => sessionStorage.setItem('firmaId', item.firmaId.toString())),
                    tap((item) => sessionStorage.setItem('userId', item.id.toString())),
                    tap((item) => sessionStorage.setItem('email', item.email.toString())),
                    tap((item) => sessionStorage.setItem('rolleId', item.rolleId.toString())),
                    tap((item) => sessionStorage.setItem('session', item.session.toString())),
                    mergeMap((response) => of(
                      loadUserSucceeded({ item: response }),
                      loadFirmaStart(),
                      loadUserRollenStart(),
                      loadRollenStart(),
                      ),
                    ),
                    catchError((e) => of(loadUserFailed(e))),
                ),
            ),
        ),
    );

    /**
     * Constructor of address effects
     *
     * @param actions$ - The action observable
     * @param addressesService - The address service
     */
    constructor(private actions$: Actions, private userService: UserService) {}
}
